import React, { useCallback, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { GATEWAY_FLOW_TYPE } from 'groverPaymentSDK';

import { darkTheme, lightTheme } from 'ggApp/shared/themes';
import { LayoutComponent_LocalLoader as LocalLoader } from 'ggApp/modules/layout';

import PaymentOptionsList from './PaymentOptionsList';

import CreditCardForm from '../CreditCard/NewFlow/Form';
import AdyenFormWrap from '../CreditCard/Adyen/FormWrap';
import RedirectForm from '../RedirectForm';

const selectGatewayComponent = (gateway, withNewFlowCard) => {
    if (!gateway) {
        return null;
    }

    const { flow_type: flowType } = gateway;

    if (flowType === GATEWAY_FLOW_TYPE.CREDIT_CARD) {
        return withNewFlowCard ? CreditCardForm : AdyenFormWrap;
    }

    if (flowType === GATEWAY_FLOW_TYPE.REDIRECT) {
        return RedirectForm;
    }

    return null;
};

const GatewaySelectorUi = ({
    isPaymentGatewaysLoading,
    isDarkMode,
    paymentGateways,
    onPaymentMethodCreated,
    children,
    onLegacyPaymentMethodCreated,
    withNewFlowCard,
    orderNumber,
}) => {
    const [activeGateway, setActiveGateway] = useState();

    const selectPaymentGateway = useCallback(
        (gatewayId) => {
            setActiveGateway(paymentGateways.find((gateways) => gateways.id === gatewayId));
        },
        [paymentGateways],
    );

    const GatewayComponent = selectGatewayComponent(activeGateway, withNewFlowCard);

    return (
        <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
            <>
                <LocalLoader active={isPaymentGatewaysLoading} dark={isDarkMode} />

                {!isPaymentGatewaysLoading && (
                    <PaymentOptionsList
                        dark={isDarkMode}
                        paymentOptions={paymentGateways}
                        activePaymentOptionId={activeGateway?.id}
                        onPaymentOptionClick={selectPaymentGateway}
                    />
                )}

                {activeGateway && (
                    <GatewayComponent
                        orderNumber={orderNumber}
                        darkTheme={isDarkMode}
                        gateway={activeGateway}
                        onPaymentMethodCreated={onPaymentMethodCreated}
                        onLegacyPaymentMethodCreated={onLegacyPaymentMethodCreated}
                    />
                )}

                {!activeGateway && children}
            </>
        </ThemeProvider>
    );
};

export default GatewaySelectorUi;
